"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalHeader;

var _x = _interopRequireDefault(require("@ux/icon/x"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("@ux/button"));

const DEFAULT_ARIA_LABELS = {
  close: 'Close modal'
};
/**
 * Representation of a Header in the Dialog.
 */

function ModalHeader({
  children,
  onClick,
  id,
  ariaLabels = DEFAULT_ARIA_LABELS
}) {
  const close = typeof onClick === 'function' && /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": ariaLabels.close,
    className: "modal-close",
    "data-action": "close",
    "data-dismiss": "modal",
    design: "stateless",
    onClick: onClick,
    icon: /*#__PURE__*/_react.default.createElement(_x.default, null)
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, close, /*#__PURE__*/_react.default.createElement("h2", {
    className: "modal-title",
    id: id
  }, children));
}

ModalHeader.propTypes = {
  /** Header function to close the modal or boolean to hide it */
  onClick: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),

  /** aria labels */
  ariaLabels: _propTypes.default.object,

  /** ID for a11y */
  id: _propTypes.default.string,

  /** Child elements */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};